import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Link from "next/link";
import { Typography } from "@parkschannel/ui";
import classNames from "classnames";
import { useRouter } from "next/router";
export const MainTabs = (param)=>{
    let { links  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative pt-12 mb-10 w-full",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full overflow-x-auto overflow-y-hidden snap-mandatory snap-both",
                children: [
                    links.map((link)=>/*#__PURE__*/ _jsx(UserPageLink, {
                            data: link
                        }, link.href)),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute z-10 top-1/2 -right-[16px] -translate-y-1/2 h-[110%] w-[50px] bg-gradient-to-r from-background-basic/25 to-background-basic/95 md:hidden"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-full h-[1.5px] bg-neutral-200 absolute bottom-0 left-0"
            })
        ]
    });
};
function UserPageLink(param) {
    let { data  } = param;
    const router = useRouter();
    const current = router.pathname === data.match;
    return /*#__PURE__*/ _jsx(Link, {
        href: data.href,
        className: classNames("pb-4 px-4 relative z-10 flex items-center snap-start", {
            "border-b-2 border-neutral-600": current
        }),
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "h5",
            component: "h2",
            className: classNames("min-w-fit whitespace-nowrap", {
                "text-neutral-900": current,
                "text-neutral-400": !current
            }),
            children: data.text
        })
    });
}
export const LinkCounter = (param)=>{
    let { name , counter  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("flex gap-2 items-center"),
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: name
            }),
            counter && /*#__PURE__*/ _jsx(Typography, {
                variant: "bodyLarge",
                className: "block min-w-[32px] h-8 px-2 rounded-full bg-white flex items-center justify-center font-normal",
                children: counter
            })
        ]
    });
};
